"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var application_1 = require("../../models/application");
var constants = require("../../shared/code/Constants");
function view() {
    var _this = this;
    return {
        state: {
            actionItem: this.props.actionItem,
            parentTag: "",
            constants: constants
        },
        initialize: function () {
            return new Promise(function (resolve) {
                _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            userAnswerChanged: function (answer) {
                _this.view.state.actionItem.isUserOptedIn = answer;
                _this.view.helpers.returnResultsToPage();
            }
        },
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.SubmitResultData();
                resultData.actionId = _this.view.state.actionItem.id;
                resultData.type = application_1.ActionType.submit;
                resultData.isUserOptedIn = _this.view.state.actionItem.isUserOptedIn;
                _this.props.onDataChanged(resultData);
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowSubmitAction/View.js
// module id = 768
// module chunks = 0